import { useEffect, useRef } from 'react'

interface UseFocusWithinProps {
  onBlur?: () => void
  onFocus?: () => void
}

export const useFocusWithin = ({ onBlur, onFocus }: UseFocusWithinProps) => {
  const ref = useRef<HTMLElement>(null)

  useEffect(() => {
    const element = ref.current

    if (!element) return

    const handleBlur = () => {
      setTimeout(() => {
        if (element && !element.contains(document.activeElement)) {
          onBlur?.()
        }
      }, 0)
    }

    const handleFocus = () => {
      onFocus?.()
    }

    element.addEventListener('focusin', handleFocus)
    element.addEventListener('focusout', handleBlur)

    return () => {
      element.removeEventListener('focusin', handleFocus)
      element.removeEventListener('focusout', handleBlur)
    }
  }, [onBlur, onFocus])

  return { ref }
}
